/** Entry point file that is included in all pages of the user portal. */

import { getGlobalThis, parseRecord } from "@de-xima/xima-common-js-lang";
import { onScriptLoaded } from "./common/init.ts";

import {
  createGlobalComponentsExports,
  createFormUtilExports,
  createGlobalPagesExports,
  createGlobalSimplebarExports,
  createGlobalLayoutExports,
} from "./pages/global-scope.ts";

onScriptLoaded();

parseRecord(getGlobalThis()).FcUserPortal = {
  ...createGlobalPagesExports(),
  ...createGlobalSimplebarExports(),
  ...createGlobalLayoutExports(),
  ...createGlobalComponentsExports(),
  ...createFormUtilExports(),
};
